module.exports = __webpack_public_path__ + "img/GAME_SOUNDLINK.015162f0.png";